export const ResourcesValue = {
  POSTS: 'posts',
  USERS: 'users',
  ROLES: 'roles',
  ROLE_USERS: 'roleUsers',
  PERMISSIONS: 'permissions',
  SMS: 'sms',
  DEPARTMENTS: 'departments',
  JOB_TITLES: 'jobTitles',
  REGIONS: 'regions',
  UNITS: 'units',
  TOPICS: 'topics',
  NUDGES: 'nudges',
  NUDGE_CATEGORY: 'nudgeCategories',
  NUDGE_SLIDES: 'nudgeSlides',
  KPIS: 'kpis',
  KPI_ASSIGNEES: 'kpi-assignees',
  KPI_DATA: 'kpi-data',
  USER_GROUPS: 'user-groups',
  USER_GROUP_MEMBERS: 'user-group-members',
  JOURNEYS: 'journeys',
  BADGES: 'badges',
  BADGES_AWARDS: 'badgesAwards',
  BADGE_AWARDS: 'badgeAwards',
  CHECKLISTS: 'checklists',
} as const;
export type ResourcesValue =
  (typeof ResourcesValue)[keyof typeof ResourcesValue];

export const CustomResourcesValue = {
  CHAT: 'chat',
  DASHBOARD_USERS: 'dashboard/users',
  DASHBOARD_FEED: 'dashboard/feed',
  DASHBOARD_PULSE_CHECKS: 'dashboard/pulseChecks',
} as const;
